<template>
  <div class="x3-side-container" >
    <transition name="van-fade">
      <div v-show="visible" class="x3-side-mask" @click="close"></div>
    </transition>

    <transition name="van-slide-right">
      <div class="x3-side-content" :class="{fulled: fulled}" v-if="visible">
        <!-- <slot :close="close" :confirm="confirm"></slot> -->
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  inject:['close', 'confirm'],
  props: {
    fulled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    async baseInit() {
      let meta = this.$parent.$vxRoute.meta;
      if (!meta._resolve) {
        await app.tool.timeout(0);
        // this.$router.back();
        this.close();
      } else {
        // this._resolve = meta._resolve;
        // this._reject = meta._reject;
        await app.tool.timeout(0);
        this.visible = true;
      }
    },
    // async close() {
    //   this.$router.back();
    //   // await app.tool.timeout(100)
    // },
    // async confirm(result) {
    //   if (result == 'occlude') {
    //     // 阻塞住，不用关闭弹窗
    //   } else {
    //     await this.close();
    //     result !== false && this._resolve(result);
    //   }
    // },
  },
  created() {
    this.baseInit();
  },
  watch: {
    '$parent.$vxRoute.vx_action': function (nv, ov) {
      // console.log(nv, ov);
      nv == 'vx-out' && (this.visible = false);
    },
  },
};
</script>

<style lang="scss" scoped>
.x3-side-container {
  background: transparent;
  .x3-side-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(var(--black-rgb), 0.7);
    z-index: 1;
  }
  .x3-side-content {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: var(--x3-slide-left);
    background: var(--g1);
    z-index: 2;
    display: flex;
    flex-direction: column;
    overflow: auto;
    &.fulled{
      left: 0;
    }

    ::v-deep .van-cell {
      // .van-cell__title {
      //   color: var(--g8);
      // }
      .van-cell__value {
        color: var(--g6);
        &.selected {
          color: var(--c1);
        }
      }
    }
  }
}
</style>
<style lang="scss">
.x3-side-container {
  .x3-side-content {
    .smain{
      .van-cell{
        &::after{
          display: none;
        }
      }
    }
    .three-a-row {
      margin-top: calc(var(--gap) * 8);
      position: relative;
      padding-bottom: calc(var(--gap) * 8);
      .nav-title {
        display: flex;
        padding: calc(var(--gap) * 8) calc(var(--gap) * 17) calc(var(--gap) * 1)
          calc(var(--gap) * 16);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        justify-content: space-between;
        color: var(--g7);
      }
      .nav-div {
        display: flex;
        flex-wrap: wrap;
        margin: calc(var(--gap) * 8) calc(var(--gap) * 8) 0 calc(var(--gap) * 8);
      }
      .nav-box {
        width: 33.33%;
        padding: calc(var(--gap) * 8);
        .item-nav {
          height: calc(var(--w) * 32);
          line-height: calc(var(--w) * 32);
          text-align: center;
          border-radius: var(--radius-base);
          background-color: var(--g1);
          white-space: nowrap;
          &.active,
          &.all {
            color: var(--c1);
            background-color: rgba(var(--c1-rgb), 0.08);
          }
        }
      }
      .date-box {
        padding: calc(var(--gap) * 8) calc(var(--gap) * 16) 0 calc(var(--gap) * 16);
        display: flex;
        align-items: center;
      }
      // &::after{
      //   position: absolute;
      //   box-sizing: border-box;
      //   content: ' ';
      //   pointer-events: none;
      //   left: calc(var(--gap) * 16);
      //   bottom: 0;
      //   right: calc(var(--gap) * 16);
      //   height: 1px;
      //   transform: scaleY(0.5);
      //   background-color: var(--g3);
      // }
      .arrange-nav{
        padding: calc(var(--gap) * 16);
        display: flex; 
        align-items: center;
        .van-cell{
          display: flex;
          flex: 1;
          height: calc(var(--w) * 32);
          border-radius: var(--radius-md);
          background-color: var(--g1);
          align-items: center;
          justify-content: center;
        }
        .van-field__control,
        .van-field__control--custom{
          width: 100%;
          text-align: center;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>